import { MouseEvent } from 'react';
import { linkTrackEvent } from '~/adapters/tracking/tracking';

export const gaCategory = 'Account Orders';

export const orderLinkTrackEvent = (event: MouseEvent<HTMLElement>, label: string): void =>
    linkTrackEvent(event, { action: 'accounts order', label });
